<template>
  <div class="welcome-card">
    <!-- DEKORASI BACKGROUND (Tetap dipertahankan) -->
    <div class="decoration-wizard-hat">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          d="M410.5 448c-1.4-1.1-2.9-2.2-4.4-3.3c-2.3-1.6-4.7-3.1-7.2-4.5c-15.1-8.5-32.5-14.2-51.2-16.1c-16.1-1.7-33-3.2-50.6-4.4C261.2 417.2 220 416 176 416s-85.2 1.2-121.1 3.7c-17.6 1.2-34.5 2.7-50.6 4.4c-18.7 1.9-36.1 7.6-51.2 16.1c-2.5 1.4-4.9 2.9-7.2 4.5c-1.5 1.1-2.9 2.2-4.4 3.3c-3 2.3-3.5 6.4-1.3 9.4l0 0c2.4 3.3 7 4 10.3 1.5c1.4-1.1 2.9-2.2 4.4-3.3c2.3-1.6 4.7-3.1 7.2-4.5c15.1-8.5 32.5-14.2 51.2-16.1c16.1-1.7 33-3.2 50.6-4.4C100.8 417.2 142 416 186 416s85.2 1.2 121.1 3.7c17.6 1.2 34.5 2.7 50.6 4.4c18.7 1.9 36.1 7.6 51.2 16.1c2.5 1.4 4.9 2.9 7.2 4.5c1.5 1.1 2.9 2.2 4.4 3.3c3.3 2.5 7.9 1.8 10.3-1.5l0 0c2.2-3 1.7-7.1-1.3-9.4zM176 0c-17.7 0-32 14.3-32 32c0 1.6 .1 3.2 .4 4.7L81.4 256H270.6L207.6 36.7C207.9 35.2 208 33.6 208 32c0-17.7-14.3-32-32-32zM32 288c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H32z" />
      </svg>
    </div>
    <div class="decoration-maracas">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          d="M352 96c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zm-96 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128z" />
      </svg>
    </div>

    <!-- ===== FORM VIEW ===== -->
    <template v-if="cardView === 'FORM'">

    <!-- ABBY HERO SECTION -->
    <div class="welcome-hero">
      <div class="abby-mascot">
        <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby Mascot" class="abby-img"/>
      </div>
      <div class="abby-speech">
        <h2 class="title-welcome">Halo! Aku Abby ✨</h2>
        <p class="subtitle">Aku akan bantu kamu untuk mendaftar di Petra Parade ya! Pertama-tama kenalan dulu, yuk.</p>
      </div>
    </div>

    <div class="card-content">
      <form @submit.prevent="validateAndStartQuiz" class="data-form" novalidate>
        <!-- INSTRUKSI DATA DIRI -->
        <p class="section-instruction">Tulis nama lengkapmu dan data lainnya di bawah ini:</p>

        <div class="input-group">
          <label for="fullName" class="floating-label">Nama Lengkap</label>
          <div class="input-wrapper" :class="{ 'has-error': errors.name }">
            <span class="input-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
              </svg></span>
            <input id="fullName" type="text" v-model="localData.name" @input="errors.name = null"
              placeholder="Tulis nama lengkap kamu..." maxlength="80" />
          </div>
          <p v-if="errors.name" class="error-message">{{ errors.name }}</p>
        </div>

        <div class="input-group">
          <label for="school" class="floating-label">Asal Sekolah</label>
          <div class="input-wrapper select-wrapper" :class="{ 'has-error': errors.school }">
            <span class="input-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path
                  d="M511.8 287.6L512 288h.2l11.4 6.5c-4.9 2.1-9.9 4-15.1 5.7L512 304V288c0-2.2-.2-4.4-.4-6.6l-3.3 2.2zM457.1 262.3l-5.7-3.2C451.2 257.6 451 256 451 254.3V223.7c0-1.7 .2-3.4 .7-5.1l5.7-3.2c10-5.7 16.7-16.5 16.7-28.5V160c0-25.5-21.2-48-48-48H48c-26.8 0-48 22.5-48 48v256c0 25.5 21.2 48 48 48h352c26.8 0 48-22.5 48-48V320c0-12-6.7-22.8-16.7-28.5zM320 256c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80z" />
              </svg></span>
            <Multiselect v-model="localData.school" :options="allSchoolOptions" :searchable="true"
              :create-option="allowNewSchool" @select="errors.school = null" placeholder="Ketik untuk mencari"
              :no-options-text="allowNewSchool ? 'Ketik untuk menambah sekolah baru' : 'Ketik untuk mencari'"
              no-results-text="Sekolah tidak ditemukan" class="multiselect-custom" />
          </div>
          <p v-if="errors.school" class="error-message">{{ errors.school }}</p>
        </div>

        <div v-if="showGrade" class="input-group">
          <label class="floating-label">Kelas</label>
          <div class="input-wrapper radio-wrapper" :class="{ 'has-error': errors.grade }">
            <label class="radio-label" :class="{ 'is-checked': localData.grade === 'XI' }" @click="errors.grade = null"><input type="radio" v-model="localData.grade"
                value="XI" name="grade" /><span>XI</span></label>
            <label class="radio-label" :class="{ 'is-checked': localData.grade === 'XII' }" @click="errors.grade = null"><input type="radio" v-model="localData.grade"
                value="XII" name="grade" /><span>XII</span></label>
            <label class="radio-label" :class="{ 'is-checked': localData.grade === 'Lainnya' }" @click="errors.grade = null"><input type="radio" v-model="localData.grade"
                value="Lainnya" name="grade" /><span>Lainnya</span></label>
          </div>
          <p v-if="errors.grade" class="error-message">{{ errors.grade }}</p>
        </div>

        <div v-if="showGrade && showParalel" class="input-group">
          <label for="paralel" class="floating-label">Kelas Paralel</label>
          <div class="input-wrapper" :class="{ 'has-error': errors.paralel }">
            <span class="input-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zM0 352c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V352z" />
              </svg></span>
            <input id="paralel" type="text" v-model="localData.paralel" @input="errors.paralel = null"
              :placeholder="localData.grade === 'XI' || localData.grade === 'XII' ? 'Contoh: A / 3' : localData.grade === 'Lainnya' ? 'Contoh: X-A / 10 MIPA 1' : 'Contoh: A / 3'" />
          </div>
          <p v-if="errors.paralel" class="error-message">{{ errors.paralel }}</p>
        </div>

        <!-- INSTRUKSI KONTAK UPDATE -->
        <div class="contact-callout">
          <p>Info Email dan nomor WhatsApp kamu di sini, ya! Supaya aku bisa kirimin kamu update terbaru seputar Petra Parade 2026. 🚀
          </p>
        </div>
        <div class="input-group">
          <label for="email" class="floating-label">Email Pribadi</label>
          <div class="input-wrapper" :class="{ 'has-error': errors.email }">
            <span class="input-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
              </svg></span>
            <input id="email" type="email" v-model="localData.email" @input="errors.email = null"
              placeholder="Email aktif kamu..." />
          </div>
          <!-- Label khusus email -->
          <p class="email-hint">Mohon gunakan email pribadi, bukan email dari sekolah ya.</p>
          <p v-if="errors.email" class="error-message">{{ errors.email }}</p>
        </div>

        <div class="input-group">
          <label for="phone" class="floating-label">No. Handphone (WhatsApp)</label>
          <div class="input-wrapper" :class="{ 'has-error': errors.phone }">
            <span class="input-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
              </svg></span>
            <input id="phone" type="tel" v-model="localData.phone" @input="errors.phone = null"
              @blur="handlePhoneBlur"
              placeholder="Contoh: 08123456789" maxlength="15" />
          </div>
          <p v-if="errors.phone" class="error-message">{{ errors.phone }}</p>
        </div>

        <p class="disclaimer">Data ini akan digunakan untuk presensi kegiatan Petra Parade 2026.</p>
        <button type="submit" class="start-button" :class="{ 'is-checking': isChecking }" :disabled="isChecking">
          <span v-if="!isChecking">Mulai Sekarang 🚀</span>
          <span v-else class="loading-content">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </span>
        </button>
      </form>

      <!-- Ghost button: Cek Hasil Test -->
      <div class="cr-footer">
        <div class="cr-divider"><span>atau</span></div>
        <button type="button" @click="cardView = 'CHECK_RESULT'" class="ghost-check-btn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ghost-icon"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
          Sudah terdaftar? Cek hasil test kamu
        </button>
      </div>
    </div><!-- end .card-content -->
    </template><!-- end FORM VIEW -->

    <!-- ===== DUPLICATE VIEW ===== -->
    <template v-else-if="cardView === 'DUPLICATE'">
      <div class="alt-hero alt-hero--warn">
        <div class="abby-mascot">
          <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby Mascot" class="abby-img"/>
        </div>
        <div class="abby-speech abby-speech--warn">
          <h2 class="title-welcome">Hei, kamu sudah terdaftar! 🎉</h2>
          <p class="subtitle">Email atau nomor HP ini sudah pernah digunakan untuk mendaftar Petra Parade 2026.</p>
        </div>
      </div>
      <div class="card-content">
        <div class="dup-info-box">
          <div class="dup-icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="dup-icon"><path d="M256 48a208 208 0 1 1 0 416A208 208 0 1 1 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"/></svg>
          </div>
          <div class="dup-text">
            <!-- <h3 class="dup-title">Pendaftaran Sudah Selesai</h3> -->
            <p class="dup-desc">Kamu sudah pernah menyelesaikan pendaftaran ini. Pilih salah satu opsi di bawah ini!</p>
            <!-- <div class="dup-contact-chips">
              <span class="dup-chip">📧 {{ duplicateEmail }}</span>
            </div> -->
          </div>
        </div>
        <div class="dup-actions">
          <button type="button" @click="handleDuplicateCheckResult" class="dup-btn dup-btn--primary">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="dup-btn-icon"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>
            Cek Hasil Pendaftaran Saya
          </button>
          <button type="button" @click="handleDuplicateRegisterNew" class="dup-btn dup-btn--secondary">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="dup-btn-icon"><path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/></svg>
            Daftar Ulang dengan Data Baru
          </button>
        </div>
      </div>
    </template><!-- end DUPLICATE VIEW -->

    <!-- ===== CHECK RESULT VIEW ===== -->
    <template v-else-if="cardView === 'CHECK_RESULT'">
      <div class="alt-hero">
        <div class="abby-mascot">
          <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby Mascot" class="abby-img"/>
        </div>
        <div class="abby-speech">
          <h2 class="title-welcome">Cek Hasil Test 🔍</h2>
          <p class="subtitle">Masukkan email dan nomor HP yang kamu gunakan saat mendaftar.</p>
        </div>
      </div>
      <div class="card-content">
        <form @submit.prevent="handleCheckResultSubmit" class="data-form" novalidate>
          <div class="input-group">
            <label for="crEmail" class="floating-label">Email Pendaftaran</label>
            <div class="input-wrapper" :class="{ 'has-error': checkResultErrors.email }">
              <span class="input-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg>
              </span>
              <input id="crEmail" type="email" v-model="checkResultForm.email" @input="checkResultErrors.email = null" placeholder="Email yang kamu daftarkan..." autocomplete="email" />
            </div>
            <p v-if="checkResultErrors.email" class="error-message">{{ checkResultErrors.email }}</p>
          </div>
          <div class="input-group">
            <label for="crPhone" class="floating-label">No. HP (WhatsApp)</label>
            <div class="input-wrapper" :class="{ 'has-error': checkResultErrors.phone }">
              <span class="input-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/></svg>
              </span>
              <input id="crPhone" type="tel" v-model="checkResultForm.phone" @blur="handleCheckResultPhoneBlur" @input="checkResultErrors.phone = null" placeholder="Contoh: 08123456789" maxlength="15" autocomplete="tel" />
            </div>
            <p v-if="checkResultErrors.phone" class="error-message">{{ checkResultErrors.phone }}</p>
          </div>
          <p class="disclaimer">Kami akan mencocokkan data kamu dengan data yang sudah terdaftar.</p>
          <button type="submit" class="start-button" :class="{ 'is-checking': isCheckingResult }" :disabled="isCheckingResult">
            <span v-if="!isCheckingResult">Lihat Hasil Saya 🎯</span>
            <span v-else class="loading-content">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </span>
          </button>
        </form>
        <div class="cr-footer cr-footer--back">
          <button type="button" @click="cardView = 'FORM'" class="ghost-check-btn">
            ← Kembali ke Halaman Pendaftaran
          </button>
        </div>
      </div>
    </template><!-- end CHECK_RESULT VIEW -->

  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue';
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import { useToast } from '../composables/useToast';

const { addToast } = useToast();

const props = defineProps({
  formData: { type: Object, required: true },
  schoolList: { type: Array, required: true },
  allowNewSchool: { type: Boolean, default: true },
  showGrade: { type: Boolean, default: true },
  showParalel: { type: Boolean, default: true },
})
const emit = defineEmits(['update:formData', 'start', 'resume-student']);

const localData = computed({
  get: () => props.formData,
  set: (value) => emit('update:formData', value),
})

const isChecking = ref(false);

const errors = reactive({
  name: null,
  school: null,
  grade: null,
  paralel: null,
  email: null,
  phone: null,
});

watch(() => localData.value.grade, (newGrade) => {
  if (newGrade !== 'Lainnya') {
    errors.paralel = null;
  }
});

watch(() => props.showGrade, (val) => {
  if (!val) {
    localData.value.grade = '';
    localData.value.paralel = '';
    errors.grade = null;
    errors.paralel = null;
  }
});

watch(() => props.showParalel, (val) => {
  if (!val) {
    localData.value.paralel = '';
    errors.paralel = null;
  }
});

function normalizePhone(raw) {
  const digits = (raw || '').replace(/\D/g, '');
  if (digits.startsWith('62')) return '0' + digits.slice(2);
  return digits;
}

function handlePhoneBlur() {
  if (localData.value.phone) {
    localData.value.phone = normalizePhone(localData.value.phone);
  }
}

async function validateAndStartQuiz() {
  errors.name = !localData.value.name?.trim() ? "Nama lengkap wajib diisi." : null;
  errors.school = !localData.value.school ? "Asal sekolah wajib dipilih." : null;

  if (props.showGrade) {
    errors.grade = !localData.value.grade ? "Kelas wajib dipilih." : null;
    if (props.showParalel && localData.value.grade === 'Lainnya' && !localData.value.paralel?.trim()) {
      errors.paralel = "Kelas paralel wajib diisi jika memilih 'Lainnya'.";
    } else {
      errors.paralel = null;
    }
  } else {
    errors.grade = null;
    errors.paralel = null;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!localData.value.email?.trim()) {
    errors.email = "Email wajib diisi.";
  } else if (!emailRegex.test(localData.value.email)) {
    errors.email = "Format email tidak valid.";
  } else {
    errors.email = null;
  }

  const normalizedPhone = normalizePhone(localData.value.phone);
  if (!localData.value.phone?.trim()) {
    errors.phone = "Nomor handphone wajib diisi.";
  } else if (!/^0[0-9]{8,12}$/.test(normalizedPhone)) {
    errors.phone = "Format nomor HP tidak valid. Contoh: 08123456789";
  } else {
    localData.value.phone = normalizedPhone;
    errors.phone = null;
  }

  const isValid = !errors.name && !errors.school && !errors.grade && !errors.paralel && !errors.email && !errors.phone;
  if (!isValid) return;

  isChecking.value = true;
  try {
    const baseUrl = process.env.VUE_APP_API_URL;
    const response = await fetch(`${baseUrl}/check-duplicate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ email: localData.value.email, phone: localData.value.phone }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.exists) {
        if (data.field === 'both') {
          // Both email AND phone match — same person already registered
          duplicateEmail.value = localData.value.email;
          duplicatePhone.value = localData.value.phone;
          cardView.value = 'DUPLICATE';
          return;
        }
        // Only one field matched — data mismatch, warn via toast
        if (data.field === 'email') {
          addToast('Email ini sudah terdaftar, namun nomor HP yang kamu masukkan tidak cocok dengan data kami. Pastikan nomor HP sudah benar.', 'error');
        } else if (data.field === 'phone') {
          addToast('Nomor HP ini sudah terdaftar, namun email yang kamu masukkan tidak cocok dengan data kami. Pastikan email sudah benar.', 'error');
        } else {
          addToast('Email atau nomor HP yang kamu masukkan sudah terdaftar. Silakan periksa kembali data kamu.', 'error');
        }
        return;
      }
    } else {
      errors.email = "Gagal memeriksa data. Silakan coba lagi.";
      return;
    }
  } catch {
    errors.email = "Tidak dapat terhubung ke server. Coba lagi.";
    return;
  } finally {
    isChecking.value = false;
  }

  emit('start');
}

// --- DUPLICATE & CHECK RESULT STATE ---
const cardView = ref('FORM'); // 'FORM' | 'DUPLICATE' | 'CHECK_RESULT'
const duplicateEmail = ref('');
const duplicatePhone = ref('');
const checkResultForm = reactive({ email: '', phone: '' });
const checkResultErrors = reactive({ email: null, phone: null });
const isCheckingResult = ref(false);

function handleDuplicateCheckResult() {
  emit('resume-student', { email: duplicateEmail.value, phone: duplicatePhone.value });
}

function handleDuplicateRegisterNew() {
  localData.value.email = '';
  localData.value.phone = '';
  errors.email = null;
  errors.phone = null;
  cardView.value = 'FORM';
}

function handleCheckResultPhoneBlur() {
  if (checkResultForm.phone) {
    checkResultForm.phone = normalizePhone(checkResultForm.phone);
  }
}

async function handleCheckResultSubmit() {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  checkResultErrors.email = !checkResultForm.email?.trim()
    ? 'Email wajib diisi.'
    : !emailRegex.test(checkResultForm.email)
    ? 'Format email tidak valid.'
    : null;

  const normalizedPhone = normalizePhone(checkResultForm.phone);
  if (!checkResultForm.phone?.trim()) {
    checkResultErrors.phone = 'Nomor HP wajib diisi.';
  } else if (!/^0[0-9]{8,12}$/.test(normalizedPhone)) {
    checkResultErrors.phone = 'Format nomor HP tidak valid. Contoh: 08123456789';
  } else {
    checkResultForm.phone = normalizedPhone;
    checkResultErrors.phone = null;
  }

  if (checkResultErrors.email || checkResultErrors.phone) return;

  isCheckingResult.value = true;
  try {
    emit('resume-student', { email: checkResultForm.email, phone: checkResultForm.phone });
  } finally {
    isCheckingResult.value = false;
  }
}

const allSchoolOptions = computed(() =>
  props.schoolList.map(name => ({ value: name, label: name }))
)
</script>

<style scoped>
/* Pengaturan Dasar Kartu */
.welcome-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 0;
  width: 95%;
  max-width: 550px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.7);
}

/* === WELCOME HERO: ABBY SECTION === */
.welcome-hero {
  background: linear-gradient(135deg, #ddeeff 0%, #edf6ff 100%);
  border-radius: 24px 24px 0 0;
  padding: 1.5rem 1.25rem 0;
  display: flex;
  align-items: flex-end;
  gap: 1.25rem;
  position: relative;
  z-index: 1;
}

.abby-mascot {
  flex-shrink: 0;
}

.abby-img {
  width: 130px;
  object-fit: contain;
  display: block;
  animation: float-abby 3s ease-in-out infinite;
  -webkit-mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
}

.abby-speech {
  flex: 1;
  margin-bottom: 1.25rem;
  transform: rotate(-1deg);
  position: relative;
  background: #ffffff;
  border: 2px solid #26488A;
  border-radius: 16px;
  padding: 12px 16px;
  font-weight: 500;
  box-shadow: 3px 3px 0 #26488A;
}

/* Ekor bubble */
.abby-speech::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 30px;

  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #26488A; /* border luar */
}

.abby-speech::after {
  content: "";
  position: absolute;
  left: -7px;
  top: 30px;

  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-right: 9px solid white; /* isi bubble */
}

.abby-speech h2 {
  font-size: 1.2rem;
  margin: 0 0 5px 0;
  flex: 1;
}

.abby-speech .subtitle {
  font-size: 0.9rem;
  margin-top: 0;
  line-height: 1.4;
  color: #4a5568;
}

.section-instruction {
  font-size: 0.9rem;
  color: #26488A;
  font-weight: 700;
  margin-bottom: 25px;
  text-align: left;
  padding-left: 5px;
}

.contact-callout {
  background: transparent;
  padding: 0px 15px;
  border-radius: 12px;
  border-left: 5px solid #26488A;
  margin-bottom: 25px;
  text-align: left;
}

.contact-callout p {
  margin: 0;
  font-size: 0.85rem;
  color: #26488A;
  line-height: 1.5;
  font-weight: 600;
}

.email-hint {
  font-size: 0.75rem;
  color: #a0aec0;
  margin-top: 6px;
  text-align: left;
  padding-left: 5px;
}

@keyframes float-abby {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }
}

/* === Dekorasi Background === */
@keyframes float {

  0%,
  100% {
    transform: translateY(0) rotate(var(--r, -10deg));
  }

  50% {
    transform: translateY(-10px) rotate(var(--r, -10deg));
  }
}

.welcome-card [class^="decoration-"] {
  position: absolute;
  z-index: 0;
  opacity: 0.4;
  pointer-events: none;
}

.welcome-card [class^="decoration-"] svg {
  width: 100%;
  height: 100%;
}

.decoration-wizard-hat {
  width: 140px;
  height: 140px;
  top: -25px;
  left: -25px;
  --r: -20deg;
  /* animation: float 8s ease-in-out infinite; */
}

.decoration-wizard-hat svg path {
  fill: #4489C6;
}

.decoration-maracas {
  width: 120px;
  height: 120px;
  top: -10px;
  right: -25px;
  transform: rotate(25deg);
  animation: float 8s ease-in-out infinite;
}

.decoration-maracas svg path {
  fill: #d6accc;
}

/* === Pengaturan Konten Form === */
.card-content {
  position: relative;
  z-index: 1;
  padding: 1.5rem;
}

h2 {
  color: #26488A;
  font-weight: 800;
}

.data-form {
  text-align: left;
}

.input-group { position: relative; margin-bottom: 2.5rem; }
.floating-label { position: absolute; top: -12px; left: 32px; background-color: #26488A; color: white; padding: 4px 12px; border-radius: 12px; font-size: 0.8rem; font-weight: 700; letter-spacing: 0.5px; z-index: 2; box-shadow: 0 2px 5px rgba(0,0,0,0.2); }
.input-wrapper { display: flex; align-items: center; background-color: #F2F2F3; border: 2px solid #e0e0e0; border-radius: 16px; padding-left: 12px; transition: all 0.3s ease; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), inset 0 2px 4px -1px rgba(0,0,0,0.04); }
.input-group:focus-within .input-wrapper { border-color: #4489C6; box-shadow: 0 4px 8px -1px rgba(0,0,0,0.1), inset 0 2px 4px -1px rgba(0,0,0,0.06); }
.input-icon { display: flex; align-items: center; justify-content: center; margin-right: 8px; }
.input-icon svg { width: 18px; height: 18px; fill: #95a5a6; }
input[type="text"], input[type="email"], input[type="tel"], select { width: 100%; padding: 14px 10px; border: none; background: transparent; font-size: 1rem; font-family: 'Epilogue', sans-serif; color: #2c3e50; outline: none; }
select { cursor: pointer; -webkit-appearance: none; -moz-appearance: none; appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath fill='%2395a5a6' d='M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 14px center; background-size: 14px; padding-right: 40px; }
.radio-wrapper { justify-content: space-around; padding-left: 0; padding: 6px; }
.radio-label { display: flex; align-items: center; gap: 0.5rem; padding: 8px 12px; border: 2px solid transparent; border-radius: 12px; cursor: pointer; transition: all 0.3s ease; }
/* Replaced :has(input:checked) with .is-checked class — :has() unsupported on iOS Safari < 15.4 */
.radio-label.is-checked { background-color: #eaf2fb; border-color: #4489C6; }
.radio-label input { display: none; }
.radio-label span::before { content: ''; display: inline-block; width: 18px; height: 18px; border: 2px solid #bdc3c7; border-radius: 50%; margin-right: 8px; transition: all 0.2s ease; }
.radio-label.is-checked span::before { border-color: #4489C6; background-color: #DF654D; box-shadow: inset 0 0 0 3px white; }
.disclaimer {
  font-size: 0.8rem;
  color: #777;
  text-align: center;
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.start-button { width: 100%; background-color: #26488A; color: white; border: 3px solid #1e272e; padding: 16px; font-family: 'Epilogue', sans-serif; font-size: 1.1rem; font-weight: 700; border-radius: 16px; cursor: pointer; transition: all 0.2s ease-out; position: relative; }
.start-button:disabled { opacity: 0.65; cursor: not-allowed; transform: none !important; }
.start-button.is-checking { opacity: 1; }

/* Loading dots */
.loading-content {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: white;
  animation: dot-bounce 1.2s ease-in-out infinite;
}
.dot:nth-child(1) { animation-delay: 0s; }
.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }
@keyframes dot-bounce {
  0%, 80%, 100% { transform: translateY(0) scale(1); opacity: 0.7; }
  40% { transform: translateY(-10px) scale(1.2); opacity: 1; }
}
.start-button:disabled::after { transform: translate(6px, 6px) !important; }
.start-button::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #1e272e; border-radius: 12px; transform: translate(6px, 6px); z-index: -1; transition: transform 0.2s ease-out; }
.start-button:hover { transform: translate(2px, 2px); }
.start-button:hover::after { transform: translate(4px, 4px); }
.start-button:active { transform: translate(6px, 6px); }
.start-button:active::after { transform: translate(0, 0); }

.error-message {
  color: #DF654D;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 0.5rem;
  padding-left: 0.5rem;
}
.input-wrapper.has-error {
  border-color: #DF654D;
  animation: shake 0.4s;
}


@media (max-width: 768px) {
  .welcome-hero {
    padding: 1.25rem 1rem 0;
    gap: 0.75rem;
  }

  .abby-img {
    width: 110px;
  }

  .welcome-card {
    width: 100%;
  }

  .disclaimer{
    line-height: 1.5;
    margin-top: 0rem;
  }

  h2 { color: #26488A; margin-bottom: 0.2rem; font-size: 1.4rem; font-weight: 800; }
  .subtitle { color: #555; margin-bottom: 0; font-size: 0.9rem; }
  .floating-label { position: absolute; top: -10px; left: 28px; background-color: #26488A; color: white; padding: 3px 10px; border-radius: 10px; font-size: 0.7rem; font-weight: 700; z-index: 2; box-shadow: 0 2px 4px rgba(0,0,0,0.2); }
  input[type="text"], input[type="email"], input[type="tel"] { width: 100%; padding: 12px 8px; border: none; background: transparent; font-size: 0.8rem; font-family: 'Epilogue', sans-serif; color: #2c3e50; outline: none; }
  .multiselect-custom {
  --ms-font-size: 0.8rem; /* Dikecilkan 20% */
  }
  .multiselect-custom .multiselect-option { font-family: 'Poppins', sans-serif; font-size: 0.8rem; }
  .radio-label { display: flex; align-items: center; gap: 0.4rem; padding: 6px 10px; border: 2px solid transparent; border-radius: 8px; cursor: pointer; transition: all 0.3s ease; font-size: 0.8rem; }
  .start-button { width: 100%; background-color: #26488A; color: white; border: none; padding: 14px; font-family: 'Epilogue', sans-serif; font-size: 1rem; font-weight: 700; border-radius: 12px; cursor: pointer; transition: all 0.2s ease-out; }
  .input-group { position: relative; margin-bottom: 2rem; }

}

/* ===== ALT VIEWS (DUPLICATE / CHECK RESULT) ===== */
.alt-hero {
  background: linear-gradient(135deg, #ddeeff 0%, #edf6ff 100%);
  border-radius: 24px 24px 0 0;
  padding: 1.5rem 1.25rem 0;
  display: flex;
  align-items: flex-end;
  gap: 1.25rem;
  position: relative;
  z-index: 1;
}

.alt-hero--warn {
  background: linear-gradient(135deg, #fff8e6 0%, #fff3cd 100%);
}

.abby-speech--warn {
  border-color: #E8A500 !important;
  box-shadow: 3px 3px 0 #E8A500 !important;
}

.abby-speech--warn::before {
  border-right-color: #E8A500 !important;
}

/* ---- Duplicate info box ---- */
.dup-info-box {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: linear-gradient(135deg, #f0faf4, #e6f7ec);
  border: 1.5px solid #78BE95;
  border-radius: 16px;
  padding: 1.1rem 1.25rem;
  margin-bottom: 1.5rem;
}

.dup-icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: #78BE95;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dup-icon {
  width: 22px;
  height: 22px;
  fill: #ffffff;
}

.dup-text { flex: 1; }

.dup-title {
  font-size: 0.95rem;
  font-weight: 800;
  color: #1a4d30;
  margin: 0 0 0.35rem;
}

.dup-desc {
  font-size: 0.9rem;
  color: #2c4a3e;
  margin: 0 0 0.6rem;
  line-height: 1.5;
}

.dup-contact-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.dup-chip {
  display: inline-block;
  background: #EFF6FF;
  border: 1.5px solid #26488A;
  color: #1e3a6e;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  word-break: break-all;
}

/* ---- Duplicate action buttons ---- */
.dup-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.dup-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.9rem 1.25rem;
  border-radius: 14px;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: none;
}

.dup-btn--primary {
  background: linear-gradient(135deg, #26488A, #1e3a6e);
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(38, 72, 138, 0.3);
}

.dup-btn--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(38, 72, 138, 0.4);
}

.dup-btn--secondary {
  background: #ffffff;
  color: #26488A;
  border: 2px solid #26488A;
}

.dup-btn--secondary:hover {
  background: #f0f5ff;
  transform: translateY(-1px);
}

.dup-btn-icon {
  width: 15px;
  height: 15px;
  fill: currentColor;
  flex-shrink: 0;
}

/* ---- Ghost Cek Hasil button (bottom of form) ---- */
.cr-footer {
  text-align: center;
  padding-top: 0.75rem;
  padding-bottom: 0.25rem;
}

.cr-footer--back {
  padding-top: 0.5rem;
}

.cr-divider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.7rem;
  color: #b0bec5;
  font-size: 0.75rem;
}

.cr-divider::before,
.cr-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e8e8e8;
}

.ghost-check-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: transparent;
  border: none;
  color: #a0aec0;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.4rem 0.85rem;
  border-radius: 20px;
  transition: color 0.2s ease, background 0.2s ease;
}

.ghost-check-btn:hover {
  color: #4489C6;
  background: #f0f6ff;
}

.ghost-icon {
  width: 12px;
  height: 12px;
  fill: currentColor;
  flex-shrink: 0;
}
</style>